/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 10:06:04
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-10 10:18:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/PickAndPack/index.tsx
 */
import { get } from 'lodash';
//import css from './css.module.less';
import React from 'react';
import { SectionWrapper } from 'src/components/Layouts';
//import Category from './Components/Category';
import {
  Delivery,
  ReadyToPack,
  ReadyToShip,
} from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess';
import { IFulfillmentStatus } from 'src/types/common/order';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const PickAndPack = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    data,
    orderNo,
    onUpdate,
    onUndo,
    disabled,
    disablePrint,
    decimalPosition,
    taxIncluded,
  } = props;
  const pickedItems = get(data, IFulfillmentStatus.READY_TO_PACK, []);
  const packedItems = get(data, IFulfillmentStatus.READY_TO_SHIP, []);
  const deliveryItems = get(data, IFulfillmentStatus.READY_TO_COLLECT, []);
  const deliveringItems = get(data, IFulfillmentStatus.DELIVERING, []);
  const errorItems = get(data, IFulfillmentStatus.ERROR, []);
  const deliveredItems = get(data, IFulfillmentStatus.DELIVERED, []);
  const deliveryAllItems = deliveryItems
    .concat(deliveringItems)
    .concat(deliveredItems)
    .concat(errorItems);

  //const delivery = get(data, IFulfillmentStatus.DELIVERING, []);+get(data, IFulfillmentStatus.DELIVERING, []);

  return (
    <React.Fragment>
      {(!!pickedItems.length ||
        !!packedItems.length ||
        !!deliveryAllItems.length) && (
        <SectionWrapper
          title={getI18n(`allOrders.orderDetail.pickandpack_return_title`)}>
          {!!pickedItems.length && (
            <ReadyToPack
              data={pickedItems}
              disabled={disabled}
              orderNo={orderNo}
              onUpdate={onUpdate}
              onUndo={onUndo}
              disablePrint={disablePrint}
              decimalPosition={decimalPosition}
              taxIncluded={taxIncluded}
            />
          )}
          {!!packedItems.length && (
            <ReadyToShip
              decimalPosition={decimalPosition}
              data={packedItems}
              disabled={disabled}
              orderNo={orderNo}
              onUpdate={onUpdate}
              onUndo={onUndo}
              disablePrint={disablePrint}
              taxIncluded={taxIncluded}
            />
          )}
          {!!deliveryAllItems.length && (
            <Delivery
              decimalPosition={decimalPosition}
              data={deliveryAllItems}
              disabled={disabled}
              orderNo={orderNo}
              onUpdate={onUpdate}
              onUndo={onUndo}
              disablePrint={disablePrint}
              taxIncluded={taxIncluded}
            />
          )}
        </SectionWrapper>
      )}
    </React.Fragment>
  );
};
export default PickAndPack;
